import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  GetProcessorInstanceQuery,
  GetProcessorInstanceQueryVariables,
} from '#graphql/generated';

export const GET_PROCESSOR_INSTANCE: TypedDocumentNode<
  GetProcessorInstanceQuery,
  GetProcessorInstanceQueryVariables
> = gql`
  query GetProcessorInstance($id: String!) {
    processorInstance(id: $id) {
      id
      processorId
      userId
      status
      metadata
      value
      error
      createdAt
      updatedAt
      aiAudits(limit: 100) {
        id
        createdAt
        endpoint
        metadata
        processorId
        iteration
        maxIterations
        model
        instanceId
      }
    }
  }
`;
